import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'cms-interaction-bar',
  name: '互动栏',
  icon: '互',
  group: 'CMS通用',
  description: '内容详情页底部互动栏，包含点赞、评论、收藏、分享。',
  defaultProps: {
    showLike: true,
    showComment: true,
    showFavorite: true,
    showShare: true
  }
}
